import { Typography } from "@mui/material";

const SubTitle = ({ children, ...res }) => {
  return (
    <Typography variant="h6" color="#003568" {...res}>
      {children}
    </Typography>
  );
};

export default SubTitle;
